<template>
    <TqLoaderContainer :p_showLoader_b="loader_b">
        <div v-if="!loader_b" class="TQ_center" :data-hook="DataHooks_o.page_quest_event_media_root">
            <div v-for="(localParseData_o, teamId_uid) in localParseData_byTeamId_o" :key="teamId_uid" class=" TQ_padding_8px TQ_bg_white TQ_borderRadius TQ_margin_8px">
                <!-- 1) title  -->
                <div class="TQ_text_20px TQ_border_bottom TQ_border_top TQ_padding_8px TQ_margin_bottom_8px TQ_grid_col_1frAuto TQ_grid_verticalCenter" >
                    <div class="TQ_grid_verticalCenter">{{ localParseData_o.teamName_s }}</div>
                    <tq-image v-show="selectedTeams_byTeamId_b[teamId_uid]" @click.native="m_unselectedTeam_f(teamId_uid)" :pb_src_r="ass_img_checked_green" style="width: 32px; height: 32px" />
                    <tq-image v-show="!selectedTeams_byTeamId_b[teamId_uid]" @click.native="m_selectedTeam_f(teamId_uid)" :pb_src_r="ass_img_checked_bgWhite_g" style="width: 32px; height: 32px"  :data-hook="DataHooks_o.page_quest_event_media_choose_team_files"/>
                </div>
                
                <!-- unlockData for each team -->
                <div class="lc_tilesContainer ">
                    <div v-for="(titleAndFile_o, index_n) in localParseData_o.titleAndFile_ao" :key="index_n" class="lc_tile" :data-hook="DataHooks_o.page_quest_event_media_file">
                        
                        <tq-on-top-container>
                            <div slot="body">

                                <!-- image -->
                                <tq-image v-if="titleAndFile_o.file_c.fi_m_isImage_fb()" :pb_src_r="titleAndFile_o.file_c.fi_url_s" class="TQ_borderRadius"/>

                                <!-- video -->
                                <video v-else-if="titleAndFile_o.file_c.fi_m_isVideo_fb()"   
                                    :autoplay="false" poster="poster.jpg" muted="false" :loop="false" 
                                    class="TQ_borderRadius" controls 
                                    :src="titleAndFile_o.file_c.fi_url_s + '#t=0.0001'" ></video>

                                <!-- title -->
                                <div>
                                    {{titleAndFile_o.title_blc_s[com_displayLangCode_e]}}
                                </div>

                                <!-- sub-title -->
                                <div>
                                    {{titleAndFile_o.subTitle_blc_s[com_displayLangCode_e]}}
                                </div>

                            </div>

                            <div slot="topRight" class="TQ_padding_4px TQ_clickable" @click.stop="m_clickFile_f(titleAndFile_o.file_c, teamId_uid, index_n)" :data-hook="DataHooks_o.page_quest_event_media_choose_file">
                                <tq-image v-show="selectedFiles_byTeam_byIndex_c[teamId_uid][index_n]" :pb_src_r="ass_img_checked_green" style="width: 48px; height: 48px" />
                                <tq-image v-show="!selectedFiles_byTeam_byIndex_c[teamId_uid][index_n]" :pb_src_r="ass_img_checked_bgWhite_g" style="width: 48px; height: 48px" />
                            </div>

                        </tq-on-top-container>
                    
                    </div>
                </div>

                <div class="lc_bottomRight">
                    <div  class="TQ_bg_purple_lite TQ_padding_16px TQ_box_shadow TQ_borderRadius TQ_grid_gap_2px" @click="m_downloadImages_fs" :data-hook="DataHooks_o.page_quest_event_media_download_btn">
                        {{ass_strings.oneWord_download[store_langCode_ve.val]}} (<span :data-hook="DataHooks_o.page_quest_event_media_counter">{{selectedFileCount_n }}</span>)
                    </div>
                </div>
                

            
            </div>
        </div>
    </TqLoaderContainer>
</template>

<script>
import { route_urlLastPath_fs } from '@/router'
import { server_questEvent_once_f, server_questTicket_getOnce_fc } from '@/scripts/Server/S_ServerPre'
import { serverOngoing_gameStatus_getOnce_fpc, serverOngoing_teamStatus_subCollection_getOnce_fpc } from '@/scripts/Server/S_ServerOngoing'
import { enum_subCollection_teamStatus } from '../../../functions/src/shareCode/Share_S_Enum'
import TqImage from '@/components/basic/TqImage.vue'
import TqOnTopContainer from '@/components/basic/TqOnTopContainer.vue'
import { ass_img_checked_bgWhite_g, ass_img_checked_green, ass_img_download_w } from '@/assets/scripts/Ass_Files'
import { file_downLoadFile_fp } from '@/scripts/S_Files'
import { serverBig_questBody_once_fp } from '@/scripts/Server/S_ServerFirestore'
import TqLoaderContainer from './../../components/basic/TqLoaderContainer.vue'
import { obj_forEach_f } from '../../../functions/src/shareCode/Share_S_Obj'
import { store_getStateValue_vo, store_var } from '@/store'
import { ass_strings } from '../../../functions/src/shareCode/Share_Ass_Dictionary'
import { DataHooks_o } from '@/scripts/S_DataHooks'
export default {
  components: { TqImage, TqOnTopContainer, TqLoaderContainer },
    name: "v_QuestMedia",
    data(){
        return {
            selectedFiles_byTeam_byIndex_c: {},
            selectedFileCount_n: 0,
            loader_b: true,
            localParseData_byTeamId_o: {},
            selectedTeams_byTeamId_b: {},
            totalFiles_byTeamId_n: {},

            // store
            store_langCode_ve: store_getStateValue_vo(store_var.system_langCode),

            // imports
            ass_strings,
            ass_img_checked_green,
            ass_img_checked_bgWhite_g,
            ass_img_download_w,
            DataHooks_o,            
        }
    },
    computed:{
        com_displayLangCode_e(){
            return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_langCode_ve.val)
        }
    },
    methods:{
        m_selectedTeam_f(teamId_uid){
            this.localParseData_byTeamId_o[teamId_uid].titleAndFile_ao.forEach((titleAndFile_c, index_n) => {
                this.selectedFiles_byTeam_byIndex_c[teamId_uid][index_n] = titleAndFile_c.file_c
                this.selectedFileCount_n++
            })
            this.selectedTeams_byTeamId_b[teamId_uid] = true
        },
        m_unselectedTeam_f(teamId_uid){
            for(const index_n in  this.selectedFiles_byTeam_byIndex_c[teamId_uid]){
                delete this.selectedFiles_byTeam_byIndex_c[teamId_uid][index_n] 
                this.selectedFileCount_n--
            }
            this.selectedTeams_byTeamId_b[teamId_uid] = false
        },
        m_downloadImages_fs(){
            this.selectedFileCount_n = 0
            for(const teamId_uid in this.selectedFiles_byTeam_byIndex_c){
                for(const index_n in  this.selectedFiles_byTeam_byIndex_c[teamId_uid]){
                    const file_c = this.selectedFiles_byTeam_byIndex_c[teamId_uid][index_n]
                    file_downLoadFile_fp(file_c.fi_url_s, file_c.fi_m_uniqueFullName_s())
                }
                this.selectedFiles_byTeam_byIndex_c[teamId_uid] = {}
            }
        },
        m_clickFile_f(file_c, teamId_uid, index_n){
            if(!this.selectedFiles_byTeam_byIndex_c[teamId_uid][index_n]){
                this.selectedFiles_byTeam_byIndex_c[teamId_uid][index_n] = file_c
                this.selectedFileCount_n++
                const totalSelectedFiles = Object.values(this.selectedFiles_byTeam_byIndex_c[teamId_uid]).length
                this.selectedTeams_byTeamId_b[teamId_uid] = totalSelectedFiles === this.selectedFileCount_n
            }else{
                delete this.selectedFiles_byTeam_byIndex_c[teamId_uid][index_n]
                this.selectedFileCount_n--
                this.selectedTeams_byTeamId_b[teamId_uid] = false
            }

        }
    },

    async created(){
        // 1) get questTicket
       const ticketId_uid = route_urlLastPath_fs()
       const questTicket_c = await server_questTicket_getOnce_fc(ticketId_uid)

       if(!questTicket_c){
        return 
       }
       
       // 2) get questEvent
       const {qt_questType_e, qt_questId_uid, qt_eventId_uid} = questTicket_c

       // 3) get data from server
       const [questEvent_c, gameStatus_c, questBody_c] = await Promise.all([
            server_questEvent_once_f(qt_questType_e, qt_questId_uid, qt_eventId_uid, true), 
            serverOngoing_gameStatus_getOnce_fpc(qt_questType_e, qt_questId_uid, qt_eventId_uid), 
            serverBig_questBody_once_fp(qt_questType_e, qt_questId_uid)])
       this.server_questBody_c = questBody_c
       
       // 4) arrange riddleData by subCollection and riddleId
       const subCollectionName_ae = Object.values(enum_subCollection_teamStatus)
       const riddlesData_bySubCollection_byRiddleId_c = {}
       subCollectionName_ae.forEach(subCollection_e => riddlesData_bySubCollection_byRiddleId_c[subCollection_e] = {})
       questBody_c.qb_mapMissions_ac.forEach(qb_riddle_c => 
            riddlesData_bySubCollection_byRiddleId_c[enum_subCollection_teamStatus.MAP_MISSIONS][qb_riddle_c.qbr_riddleId_n] = qb_riddle_c)
        questBody_c.qb_mapLastMissions_ac.forEach(qb_riddle_c => 
            riddlesData_bySubCollection_byRiddleId_c[enum_subCollection_teamStatus.MAP_LAST_MISSIONS][qb_riddle_c.qbr_riddleId_n] = qb_riddle_c)
        questBody_c.qb_cardsMissions_ac.forEach(qb_riddle_c => 
            riddlesData_bySubCollection_byRiddleId_c[enum_subCollection_teamStatus.CARDS_MISSIONS][qb_riddle_c.qbr_riddleId_n] = qb_riddle_c)
        questBody_c.qb_listMissions_ac.forEach(qb_riddle_c => 
            riddlesData_bySubCollection_byRiddleId_c[enum_subCollection_teamStatus.LIST_MISSIONS][qb_riddle_c.qbr_riddleId_n] = qb_riddle_c)
        questBody_c.qb_listLastMissions_ac.forEach(qb_riddle_c => 
            riddlesData_bySubCollection_byRiddleId_c[enum_subCollection_teamStatus.LIST_LAST_MISSIONS][qb_riddle_c.qbr_riddleId_n] = qb_riddle_c)

       // 5) get teamStatus riddles 
       for(const teamId_uid in gameStatus_c.gs_teams_byTeamId){
        this.$set(this.selectedFiles_byTeam_byIndex_c, teamId_uid, {})
        this.$set(this.selectedTeams_byTeamId_b, teamId_uid, false)

        const riddleStatusAnd_bySubCollection_byRiddleId_c = {}
        await Promise.all(subCollectionName_ae.map(
            async subCollectionName_e => (
                riddleStatusAnd_bySubCollection_byRiddleId_c[subCollectionName_e] = 
                    await serverOngoing_teamStatus_subCollection_getOnce_fpc({subCollectionName_e, questEvent_c, teamId_uid})
            ) 
        ))

        const newTeamData_o = {
            teamName_s: gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s,
            titleAndFile_ao: []
        }

        // 5.1) forEach subCollection 
        obj_forEach_f(riddleStatusAnd_bySubCollection_byRiddleId_c, (riddleStatus_byRiddleId_c, subCollection_e)=> {
            // 5.2) forEach riddleStatus
            obj_forEach_f(riddleStatus_byRiddleId_c, (riddleStatus_c => {
                // 5.4) forEach riddleStatus_unlock
                obj_forEach_f(riddleStatus_c.rs_unlock_byLockId_c, (rs_unlockData_c, lockId_n) => {
                    if(rs_unlockData_c.rsud_imgFile_c){
                        this.$set(this.selectedFiles_byTeam_byIndex_c[teamId_uid],lockId_n, null)
                        
                        const riddleData_c = riddlesData_bySubCollection_byRiddleId_c[subCollection_e][riddleStatus_c.rs_riddleId_n]

                        if(riddleData_c){
                            newTeamData_o.titleAndFile_ao.push({
                                title_blc_s: riddleData_c.qbr_title_blc_s,
                                subTitle_blc_s: riddleData_c.qbr_locks_ac[lockId_n].qbrl_title_blc_s,
                                file_c: rs_unlockData_c.rsud_imgFile_c,
                            })
                        }                    
                    }
                })
            }))
        })

        this.$set(this.localParseData_byTeamId_o, teamId_uid, newTeamData_o)
        this.totalFiles_byTeamId_n[teamId_uid] = newTeamData_o.titleAndFile_ao.length
       }

       this.loader_b = false

    }
}
</script>

<style lang="scss" scoped>


.lc_tilesContainer{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    @media (max-width: 1200px) {
        grid-template-columns: repeat(4, 1fr);
    }
    @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 600px) {
        grid-template-columns: repeat(1, 1fr);
    }

    grid-gap: 4px;

    .lc_tile {
        img{
            width: 100%;
            height: 300px;
            object-fit: cover;
        }

        video{
            width: 100%;
            height: 300px;
            object-fit: cover;    
        }

        @media (min-width: 600px) {
            &:nth-child(3n){
                grid-column: span 2;
            }
        }

       
    }
}

.lc_bottomRight{
    position: fixed;
    bottom: 8px;
    right: 8px;
}



</style>
